import { RootState } from '../store'

export const selectLounges = (state: RootState) => state.lounges